import React, { useState, useEffect, useRef } from 'react';
import '../../css/huerto/scoring.css';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import '../../css/huerto/scoringTable.css';
import FunctionGeneral from '../scoring/functionsGeneral';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
} from '@mui/material';
import Input from '../../bronson/Input';

const CalculoLPA = props => {
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [metricaLPA, setmetricaPLA] = useState(props.metricaLPA);
    const [filter, setFilter] = useState([]);
    const [optMarca, setOptMarca] = useState([]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setrowsPerPage(+event.target.value);
        setPage(0);
    };
    useEffect(() => {
        if (optMarca.length === 0) {
            var año_Mayor = 0;
            var año_Menor = 99999;
            var optSelectMarca = [];
            if (metricaLPA.length > 0) {
                let optMarca = [];
                metricaLPA.forEach(element => {
                    optMarca.push([
                        element.BrandDescription,
                        element.BrandCode,
                    ]);
                    if (element.AÑO > año_Mayor) año_Mayor = element.AÑO;
                    if (element.AÑO < año_Menor) año_Menor = element.AÑO;
                });
                optMarca = new FunctionGeneral().reemplazarDuplicados(optMarca);
                optSelectMarca.push(
                    <option value="" key={'null'}>
                        Todas
                    </option>
                );
                optMarca.forEach(element => {
                    optSelectMarca.push(
                        <option value={element[1]} key={element[1]}>
                            {element[0]}
                        </option>
                    );
                });
            }
            document.getElementById('fechDesdeAño').value = año_Menor;
            document.getElementById('fechHastaAño').value = año_Mayor;
            document.getElementById('fechDesdeMes').value = 1;
            document.getElementById('fechHastaMes').value = 12;
            setOptMarca(optSelectMarca);
        }
    }, []);
    useEffect(() => {
        var actualState = props.metricaLPA;
        filter.forEach(filt => {
            var newState = [];
            var filterstr = filt[1];
            if (filt[0] === 'Opefinanciera') {
                actualState.forEach(element => {
                    if (
                        filterstr.toUpperCase() ===
                        element.POCCODOPERACION.substring(
                            0,
                            filterstr.length
                        ).toUpperCase()
                    )
                        newState.push(element);
                });
            } else if (filt[0] === 'OperacionSolicitadaCliente') {
                if (filterstr !== 'null') {
                    actualState.forEach(element => {
                        if (filterstr === element.POYINDSOLICITADOPORCLIENTE)
                            newState.push(element);
                    });
                } else newState = actualState;
            } else if (filt[0] === 'Usuario') {
                actualState.forEach(element => {
                    if (
                        filterstr.toUpperCase() ===
                        element.USR.substring(0, filterstr.length).toUpperCase()
                    )
                        newState.push(element);
                });
            } else if (filt[0] === 'Vendedor') {
                actualState.forEach(element => {
                    if (
                        filterstr.toUpperCase() ===
                        element.VENDEDOR.substring(
                            0,
                            filterstr.length
                        ).toUpperCase()
                    )
                        newState.push(element);
                });
            } else if (filt[0] === 'MarcaSelected') {
                if (filterstr != '')
                    actualState.forEach(element => {
                        if (filterstr === element.BrandCode)
                            newState.push(element);
                    });
                else newState = actualState;
            } else if (
                filt[0] === 'fechHastaAño' ||
                filt[0] === 'fechHastaMes'
            ) {
                var mes = document.getElementById('fechHastaMes').value;
                var año = document.getElementById('fechHastaAño').value;
                if (año !== '')
                    actualState.forEach(element => {
                        if (año > element.AÑO) newState.push(element);
                        else if (año == element.AÑO && mes >= element.MES)
                            newState.push(element);
                    });
            } else if (
                filt[0] === 'fechDesdeAño' ||
                filt[0] === 'fechDesdeMes'
            ) {
                var mes = document.getElementById('fechDesdeMes').value;
                var año = document.getElementById('fechDesdeAño').value;
                if (año !== '')
                    actualState.forEach(element => {
                        if (año < element.AÑO) newState.push(element);
                        else if (año == element.AÑO && mes <= element.MES)
                            newState.push(element);
                    });
            }
            /*  else if (filt[0] === 'fechHastaAño') {
                if (filterstr != '')
                    actualState.forEach(element => {
                        if (filterstr >= element.AÑO) newState.push(element);
                    });
                else newState = actualState;
            } else if (filt[0] === 'fechDesdeAño') {
                if (filterstr != '')
                    actualState.forEach(element => {
                        if (filterstr <= element.AÑO) newState.push(element);
                    });
                else newState = actualState;
            } else if (filt[0] === 'fechHastaMes') {
                if (filterstr != '')
                    actualState.forEach(element => {
                        if (filterstr >= element.MES) newState.push(element);
                    });
                else newState = actualState;
            } else if (filt[0] === 'fechDesdeMes') {
                if (filterstr != '')
                    actualState.forEach(element => {
                        if (filterstr <= element.MES) newState.push(element);
                    });
                else newState = actualState;
            }*/
            actualState = newState;
        });
        setmetricaPLA(actualState);
    }, [filter]);

    const onChangeFilter = target => {
        var _filter = [];
        var update = false;
        filter.forEach(element => {
            if (element[0] === target.target.id) {
                update = true;
                _filter.push([target.target.id, target.target.value]);
            } else _filter.push(element);
        });
        if (!update) _filter.push([target.target.id, target.target.value]);

        setFilter(_filter);
    };
    var rows = [];
    metricaLPA
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map(row =>
            rows.push(
                <TableRow
                    id={row.POCCODOPERACION + rows.length}
                    key={row.POCCODOPERACION + rows.length}
                    style={{
                        height: '48px',
                        marginTop: '5px',
                        marginBottom: '5px',
                    }}
                    className="iconHover"
                >
                    <TableCell>
                        <pre>{row.AÑO}</pre>
                    </TableCell>
                    <TableCell>{row.MES}</TableCell>
                    <TableCell>{row.POCCODOPERACION}</TableCell>
                    <TableCell>{row.NOMBRECONCE.trim()}</TableCell>
                    <TableCell>{row.USR}</TableCell>
                    <TableCell>
                        {row.POYINDSOLICITADOPORCLIENTE == 'S' ? 'Si' : 'No'}
                    </TableCell>
                    <TableCell>{row.BrandDescription}</TableCell>
                    <TableCell>{row.VENDEDOR}</TableCell>
                    <TableCell>{row.CODECONSE}</TableCell>
                    <TableCell>{row.NUMREGISTROS}</TableCell>
                </TableRow>
            )
        );

    return (
        <React.Fragment>
            <div className="u-pb-small u-rema-full-height">
                <section className="o-content-section o-page-wrap o-page-wrap--xsmall">
                    <div className="o-component-wrapper u-hide@s">
                        <span
                            className="back-to-matrix u-float-left"
                            onClick={() => props.setviewCalculoLPA(false)}
                        >
                            <i className="c-icon c-icon--[semantic-back] c-icon--small" />
                            <label className="iconHover">
                                Volver a metricas
                            </label>
                        </span>
                        <h3 className="u-text-center">
                            <div
                                className="iconHover"
                                style={{ display: 'contents' }}
                                onClick={() => props.setviewCalculoLPA(false)}
                            >
                                Metricas LPA
                            </div>
                        </h3>
                    </div>
                    <section className="o-layout__item u-1/4">
                        <h4
                            className="u-text-center"
                            style={{ paddingTop: '25px' }}
                        >
                            Filtros
                        </h4>
                        <h3 className="c-accordion__title">
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Operación Financiera
                            </button>
                        </h3>
                        <div className="c-accordion__content c-accordion__content--max-width">
                            <div
                                className="input-div"
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'Opefinanciera',
                                        type: 'text',
                                        placeHolder: 'Introduce una Operación',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Perfil solicitud cliente
                            </button>
                        </h3>
                        <div className="c-form-field__box">
                            <div className="c-input c-input--select">
                                <select
                                    id="OperacionSolicitadaCliente"
                                    className="c-input__input"
                                    defaultValue={null}
                                    onChange={onChangeFilter}
                                >
                                    <option value="null">Todos</option>
                                    <option value="S">Si</option>
                                    <option value="N">No</option>
                                </select>
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Marca
                            </button>
                        </h3>
                        <div className="c-form-field__box">
                            <div className="c-input c-input--select">
                                {optMarca.length > 0 && (
                                    <select
                                        id="MarcaSelected"
                                        className="c-input__input"
                                        onChange={onChangeFilter}
                                        defaultValue={optMarca[0]}
                                    >
                                        {optMarca}
                                    </select>
                                )}
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Usuario Log
                            </button>
                        </h3>
                        <div className="c-accordion__content c-accordion__content--max-width">
                            <div
                                className="input-div"
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'Usuario',
                                        type: 'text',
                                        placeHolder: 'Introduce un Usuario',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Vendedor original
                            </button>
                        </h3>
                        <div className="c-accordion__content c-accordion__content--max-width">
                            <div
                                className="input-div"
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'Vendedor',
                                        type: 'text',
                                        placeHolder: 'Introduce un Vendedor',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Fecha desde
                            </button>
                        </h3>
                        <div
                            className="c-accordion__content c-accordion__content--max-width"
                            style={{ display: 'flex' }}
                        >
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechDesdeAño',
                                        type: 'number',
                                        placeHolder: 'Año',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechDesdeMes',
                                        type: 'number',
                                        placeHolder: 'Mes',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Fecha hasta
                            </button>
                        </h3>
                        <div
                            className="c-accordion__content c-accordion__content--max-width"
                            style={{ display: 'flex' }}
                        >
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechHastaAño',
                                        type: 'number',
                                        placeHolder: 'Año',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechHastaMes',
                                        type: 'number',
                                        placeHolder: 'Mes',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <button
                            className="c-btn o-layout__item u-1/1"
                            style={{ marginTop: '20px' }}
                            onClick={() =>
                                props.tableCreate(
                                    metricaLPA,
                                    'metricaCalculoLPA'
                                )
                            }
                        >
                            descargar metrica LPA
                        </button>
                    </section>
                    <section className="o-layout__item u-3/4">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            minWidth: '40px',
                                            maxWidth: '40px',
                                        }}
                                    >
                                        Año
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '40px',
                                            maxWidth: '40px',
                                        }}
                                    >
                                        Mes
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '100px',
                                            maxWidth: '100px',
                                        }}
                                    >
                                        Operación
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '170px',
                                            maxWidth: '170px',
                                        }}
                                    >
                                        Concesionario
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '200px',
                                            maxWidth: '200px',
                                        }}
                                    >
                                        Usuario Log
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '70px',
                                            maxWidth: '70px',
                                        }}
                                    >
                                        Solicitud cliente
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '80px',
                                            maxWidth: '80px',
                                        }}
                                    >
                                        Marca
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '200px',
                                            maxWidth: '200px',
                                        }}
                                    >
                                        Vendedor Original
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '70px',
                                            maxWidth: '70px',
                                        }}
                                    >
                                        Cod.Conce
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '100px',
                                            maxWidth: '100px',
                                        }}
                                    >
                                        Cantidad Simulaciones
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>{rows}</TableBody>
                        </Table>
                        {metricaLPA.length > 10 && (
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50, 100, 1000]}
                                component="div"
                                count={metricaLPA.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        )}
                    </section>
                </section>
            </div>
        </React.Fragment>
    );
};

export default withCookies(withRouter(CalculoLPA));
